
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import {Tab, Tabs} from 'vant';
import { getBaseInfo } from './api';
Vue.use(Tabs);
Vue.use(Tab);
const baseUrl = '20240724BLAYH';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabData: any[] = [
    {
      title: '首页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '热点聚焦',
      path: `/${baseUrl}/hot`,
      id: 2,
    },
    {
      title: '靖观奥运',
      path: `/${baseUrl}/show`,
      id: 3,
    },
    {
      title: '赛场风云',
      path: `/${baseUrl}/court`,
      id: 4,
    },
    {
      title: '五环对话',
      path: `/${baseUrl}/dialogue`,
      id: 5,
    },
    {
      title: '奥运时间',
      path: `/${baseUrl}/olympicTime`,
      id: 6,
    },
    {
      title: '夺金时刻',
      path: `/${baseUrl}/goldTime`,
      id: 7,
    },
  ];
  tabDataTwo: any[] = [
    {
      title: '',
      path: `/${baseUrl}/home`,
      id: 0,
    },
    {
      title: '首页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '热点聚焦',
      path: `/${baseUrl}/hot`,
      id: 2,
    },
    {
      title: '靖观奥运',
      path: `/${baseUrl}/show`,
      id: 3,
    },
    {
      title: '赛场风云',
      path: `/${baseUrl}/court`,
      id: 4,
    },
    {
      title: '五环对话',
      path: `/${baseUrl}/dialogue`,
      id: 5,
    },
    {
      title: '奥运时间',
      path: `/${baseUrl}/olympicTime`,
      id: 6,
    },
    {
      title: '夺金时刻',
      path: `/${baseUrl}/goldTime`,
      id: 7,
    },
  ];
  tabDataThree: any[] = [
    {
      title: '',
      path: `home`,
      id: 1,
    },
    {
      title: '热点聚焦',
      path: `hot`,
      id: 2,
    },
    {
      title: '靖观奥运',
      path: `show`,
      id: 3,
    },
    {
      title: '赛场风云',
      path: `court`,
      id: 4,
    },
    {
      title: '五环对话',
      path: `dialogue`,
      id: 5,
    },
    {
      title: '奥运时间',
      path: `olympicTime`,
      id: 6,
    },
    {
      title: '夺金时刻',
      path: `goldTime`,
      id: 7,
    },
  ];
  activeTab = 0;
  activeTabTwo = 0;
  activeTabThree = 0;
  activeTabThreeShow = false;
  baseInfo: any = {};
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2024巴黎奥运会',
      url: location.href,
      subtitle: `2024巴黎奥运会`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2024巴黎奥运会',
        subtitle: `2024巴黎奥运会`,
        image: cover,
      });
    }
    const index = this.tabData.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    if(this.$route.path == '/20240724BLAYH/rank'){
      this.activeTabTwo = 0;
    }
    if(this.$route.path == '/20240724BLAYH/block'){
      this.activeTabThreeShow = true;
    }else{
      this.activeTabThreeShow = false;
    }
  }

  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }

  changeTab(index: number){
    const item = this.tabData[index]
    if (item.path === this.$route.path) {
      return location.reload();
    }
    this.$router.replace(item.path);
  }

  changeTabTwo(index: number){
    const item = this.tabDataTwo[index]
    if (item.path === this.$route.path) {
      return location.reload();
    }
    this.$router.replace(item.path);
  }

  changeTabThree(index: number){
    this.activeTabThreeShow = false;
    setTimeout(() => {
      this.activeTabThreeShow = true;
    }, 50);
    const item = this.tabDataThree[index];
    this.activeTabThree = 0;
    const url = 'https://activity.cqcb.com/shangyou_activity/2024h2/20240724BLAYH/'+item.path;
    if(window.isSYWebview){
      const msg = {
      action: 'mJump',
      data: JSON.stringify({
        dt: 7,
        cid: 0,
        nid: 0,
        url: url,
        })
      };
      window.handleMessage(JSON.stringify(msg));
    }else{
      window.location.href = url;
    }
  }

  inToRank(){
    this.$router.replace('rank');
  }

  inToRankTwo(){
    const url = 'https://activity.cqcb.com/shangyou_activity/2024h2/20240724BLAYH/rank';
    if(window.isSYWebview){
      const msg = {
      action: 'mJump',
      data: JSON.stringify({
        dt: 7,
        cid: 0,
        nid: 0,
        url: url,
        })
      };
      window.handleMessage(JSON.stringify(msg));
    }else{
      window.location.href = url;
    }
  }
}
